import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';

import EmailsInput from "./StepTwoComponents/CreateAlert.StepTwo.EmailsInput";
import AlertFrequency from "./StepTwoComponents/CreateAlert.StepTwo.AlertFrequency";
import SendAlertAs from "./StepTwoComponents/CreateAlert.StepTwo.SendAlertAs";

import ButtonWithInnerSpinner from './../../reusable/ButtonWithInnerSpinner/ButtonWithInnerSpinner.index';

export default class StepTwo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isStepTwoValid: false
        };

        this.validateStepTwo = this.validateStepTwo.bind(this);
        this.toggleSaveButtonDisabled = this.toggleSaveButtonDisabled.bind(this);
    }

    validateStepTwo(isStepTwoValid) {
        this.setState({isStepTwoValid: isStepTwoValid});
    }

    toggleSaveButtonDisabled(isEmailsFieldValid) {
        this.setState({isSaveButtonEnabled: isEmailsFieldValid});
    }

    componentDidMount() {
        if (this.props.data.emails) {
            this.toggleSaveButtonDisabled(true);
        }
    }

    render() {

        return (
            <div className="create-alert-page__step-two">

                <div className='create-alert-page__step-two--description'>
                    <FormattedMessage id='Alerts_Create_UIText_steps.step2.alertDeliveryOptions'/>
                </div>

                <div className='create-alert-page__step-two--title'>
                    {this.props.data ? this.props.data.name :
                        this.props.intl.formatMessage({id: 'General_CoreFunctionality_UIText_general.notAvailable'})}
                </div>

                <div className='form-container'>

                    {
                        this.props.isCreateAlertSaving ? <div className='form-container__mask'/> : null
                    }

                    <EmailsInput data={this.props.data}
                                 isStepTwoValid={this.state.isStepTwoValid}
                                 toggleSaveButtonDisabled={this.toggleSaveButtonDisabled}
                                 validateStepTwo={this.validateStepTwo}
                                 saveData={this.props.saveData}/>

                    <AlertFrequency data={this.props.data}
                                    saveData={this.props.saveData}/>

                    <SendAlertAs data={this.props.data}
                                 saveData={this.props.saveData}/>
                </div>

                <div className='navigation-buttons'>

                    <div className='navigation-buttons__left'>
                        <button type='button'
                                className='button-secondary-lg previous'
                                disabled={this.props.isCreateAlertSaving}
                                onClick={this.props.resetCreateAlertToStepOne}>
                            <FormattedMessage id='General_CoreFunctionality_UIText_general.previous'/>
                        </button>
                    </div>
                    <div className='navigation-buttons__right'>

                        { //TODO: replace button with one ButtonWithInnerSpinner with states
                            this.props.isCreateAlertSaving ?
                                <ButtonWithInnerSpinner buttonType="button"
                                                        buttonClass={'button-primary-lg save'}
                                                        buttonMessageId="General_CoreFunctionality_UIText_general.save"
                                                        buttonState={'loading'}/>
                                :
                                <button type='button'
                                        className='button-primary-lg save'
                                        disabled={!this.state.isSaveButtonEnabled || this.props.isCreateAlertSaving}
                                        onClick={this.props.saveAlert}>
                                    <FormattedMessage id='General_CoreFunctionality_UIText_general.save'/>
                                </button>
                        }
                        <button type='button'
                                className='button-secondary-lg cancel'
                                disabled={this.props.isCreateAlertSaving}
                                onClick={this.props.cancel}>
                            <FormattedMessage id='General_CoreFunctionality_UIText_general.cancel'/>
                        </button>
                    </div>

                </div>

            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsCreate/CreateAlert.StepTwo.jsx